import React from 'react';

import { makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';

import { Typography } from '../../atoms';
import { ChevronRight as ChevronRightIcon } from '../../icons';

export interface Props {
  option: any;
}

const useStyles = makeStyles((theme: Theme) => ({
  [theme.breakpoints.down('sm')]: {
    addressPartTwo: {
      color: theme.palette.grey[800],
      display: 'block',
      fontSize: theme.typography.pxToRem(13),
    },
  },
}));

export const AddressFormat = (props: Props): JSX.Element => {
  const classes = useStyles();
  const { option } = props;

  if (!option) {
    return;
  }

  const address: string = option.description;
  const adressPartOne = address.split(', ', 2).join(', ');
  const adressPartTwo = address
    .split(', ')
    .slice(2)
    .join(', ');

  const customAddressStyles = clsx(
    option.place_id === 'customAddressRequired' && 'customAddressRequired',
  );

  return (
    <div className={customAddressStyles}>
      <Typography>
        <span>{adressPartOne}</span>
        <span className={classes.addressPartTwo}> {adressPartTwo}</span>
      </Typography>

      {option.place_id === 'customAddressRequired' ? (
        <ChevronRightIcon />
      ) : null}
    </div>
  );
};
